import type React from 'react';
import type { SelectOption } from '@app/Utilities/SelectMap';
import { FormField } from './FormField';
import { SelectControl } from './Controls/SelectControl';

type SelectFieldProps<TValue extends string | number> = {
  name: string;
  label: React.ReactNode;

  options: Array<SelectOption<TValue>>;
  className?: string;
  loading?: boolean;
  placeholder?: string;

  parse?: (raw: string) => TValue;
  disabled?: boolean;
};

export const SelectField = <TValue extends string | number>({
  name,
  label,
  className,
  ...controlProps
}: SelectFieldProps<TValue>) => {
  return (
    <FormField name={name} label={label} className={className}>
      <SelectControl name={name} {...controlProps} />
    </FormField>
  );
};
